/* eslint-disable quotes */
export function animationOnScroll() {

    const $window = $(window);
    let $items = $(".has-animation");
    let duration;


    let numberData = document.querySelectorAll(".value-number");
    let isDot = Boolean;
    let isComma = Boolean;
    let beforeComma;
    let afterComma;
    let beforeDot;
    let afterDot;

    let newArr =  Array.from( numberData).map((el) => {
        
        isComma = /[,\-]/.test(el.textContent);
        isDot = /[.\-]/.test(el.textContent);
        
        if (isComma) {
            
            beforeComma = el.textContent.split(',')[0];
            afterComma = el.textContent.split(',')[1];
            el.innerHTML = `<span class="number-data" data-speed="2000">${beforeComma}</span>,<span class="number-data" data-speed="2000">${afterComma}</span>`;

        }
        if (isDot) {
            
            beforeDot = el.textContent.split('.')[0];
            afterDot = el.textContent.split('.')[1];
            
            el.innerHTML = `<span class="number-data" data-speed="2000">${beforeDot}</span>.<span class="number-data" data-speed="2000">${afterDot}</span>`;
            
        }

        return `<span class="number-data" data-speed="2000">${el}</span>`;
    
    });


    $window.on("scroll load", function () {

        $items.each(function (i, it) {

            if ($window.scrollTop() > $(it).offset().top - $window.height() * 0.95 && !$(it).hasClass("animated")) {
                $(it).addClass("animated");
              
                if ($(it).find(".value-number")) {

                    $(it).find(".value-number").each(function (i, el) {
                       
                        let number = $(this).find(".number-data");
                        number.each(function (i, el) {
                           
                            duration = $(el).data("speed");

                            $(this).prop("Counter", 0).animate({
                                Counter: $(el).text()
                            }, {
                                duration: duration,
                                easing: "swing",
                                step: function (now) {
                                   
                                    $(el).text(Math.ceil(now));
                                }
                            });
                        });
                    });
                }
            }
        });
       
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/animations.js